import { render, staticRenderFns } from "./DragList.vue?vue&type=template&id=974c669c&scoped=true&"
import script from "./DragList.vue?vue&type=script&lang=js&"
export * from "./DragList.vue?vue&type=script&lang=js&"
import style0 from "./DragList.vue?vue&type=style&index=0&id=974c669c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974c669c",
  null
  
)

export default component.exports